export const sectionColors = {
  about:  { text: "#e5c5cc" }, // very soft burgundy
  news:   { text: "#d59cab" }, // dusty rose
  tour:   { text: "#c27289" }, // muted berry
  media:  { text: "#ac4b66" }, // deep blush
  shop:   { text: "#8f2a45" }, // strong burgundy
  signup: { text: "#701828" }, // intense final burgundy
};

export const getSectionColor = (sectionId) => {
  return sectionColors[sectionId] || { text: "#ffffff" };
}; 